import { queryOptions, useQuery } from '@tanstack/react-query';
import { DocumentService } from '../service/DocumentService';
import { UserService } from '../service/UserService';

const SPACE_DOCUMENTS_STALE_TIME_MS = 30 * 1000;

const spaceDocumentsQueries = {
  list: (spaceId: string) =>
    queryOptions({
      queryKey: ['spaceDocuments', spaceId] as const,
      queryFn: async () => {
        const response = await DocumentService.getSpaceDocuments(spaceId);
        return response.data;
      },
      staleTime: SPACE_DOCUMENTS_STALE_TIME_MS,
    }),
};

const userDocumentsQueries = {
  list: () =>
    queryOptions({
      queryKey: ['userDocuments'] as const,
      queryFn: async () => {
        const response = await UserService.getUserSpaceDocuments();
        return response.data;
      },
      staleTime: SPACE_DOCUMENTS_STALE_TIME_MS,
    }),
};

const useSpaceDocumentsQuery = (spaceId: string | null | undefined) =>
  useQuery({
    ...spaceDocumentsQueries.list(spaceId ?? ''),
    enabled: Boolean(spaceId),
  });

const useUserDocumentsQuery = (options?: { enabled?: boolean }) =>
  useQuery({
    ...userDocumentsQueries.list(),
    enabled: options?.enabled ?? true,
  });

export { spaceDocumentsQueries, userDocumentsQueries, useSpaceDocumentsQuery, useUserDocumentsQuery };
